<h2 mat-dialog-title class="dialog_title">
    <span (click)="log()">
        {{data.file.filename}} {{ "related documents" | translate }}:
    </span>
    <button class="ml-1" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography">
    <div class="container post_docs form_wrapper" [appDeviceClass]="'custom-scroll'">
        <ng-container *ngIf="!isLoadFiles; else elseTemplateHasFiles">
            <div class="d-f-c" style="height: 300px; justify-content: center;">
                <mat-spinner></mat-spinner>
            </div>
        </ng-container>
        <ng-template #elseTemplateHasFiles>
            <div class="post_doc" *ngFor="let item of files">
                <h1>{{item?.filename}}</h1>
                <h3 *ngIf="item?.language">{{item?.language?.parameterValue?.value}}</h3>
                <ng-container *ngIf="item.interfaceData">
                    <mat-icon class="is_edited" *ngIf="item?.interfaceData.is_edit">edit</mat-icon>
        
                    <ng-container *ngIf="data.normalDoc; else elseTemplate">
                        <div class="note_wrp">
                            <div class="content_editable" (input)="onChangeField($event, item)" [appDeviceClass]="'custom-scroll custom-scroll-t'" contenteditable="true" [(ngModel)]="item.interfaceData.text" matInput></div>
                        </div>
                    </ng-container>
                    <ng-template #elseTemplate>
                        <mat-form-field appearance="standard" class="full_width_form">
                            <mat-label>{{ 'Post name' | translate }}</mat-label>
                            <textarea (input)="onChangeField($event, item)"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="9" [(ngModel)]="item.interfaceData.name" matInput placeholder="{{ 'Post name' | translate }}"></textarea>
                            <mat-hint class="char_counter_hint" *ngIf="item.interfaceData.name" [ngClass]="{'red': item.interfaceData.name.length > 999999999}" align="end">{{item.interfaceData.name.length}}</mat-hint>
                        </mat-form-field>
            
                        <mat-form-field appearance="standard" class="full_width_form">
                            <mat-label>{{ 'Post description' | translate }}</mat-label>
                            <textarea (input)="onChangeField($event, item)"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="9" [(ngModel)]="item.interfaceData.desc" matInput placeholder="{{ 'Post description' | translate }}"></textarea>
                            <mat-hint class="char_counter_hint" *ngIf="item.interfaceData.desc" [ngClass]="{'red': item.interfaceData.desc.length > 999999999}" align="end">{{item.interfaceData.desc.length}}</mat-hint>
                        </mat-form-field>
                    </ng-template>
                    
                </ng-container>
            </div>
        </ng-template>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="btns">
        <button mat-raised-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="save()" mat-raised-button cdkFocusInitial color="primary" [disabled]="isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Save" | translate }}
        </button>
    </div>
</mat-dialog-actions>